import React from 'react';

/**
 * Leichter Seiten-Skeleton als Suspense-Fallback für lazy geladene Routen.
 * Bewusst ohne framer-motion/Logo: Der Fallback ist meist nur Sekundenbruchteile
 * sichtbar (Chunk-Download) und soll wie eine entstehende Seite wirken,
 * nicht wie ein blockierender Spinner.
 */
const RouteFallback = () => (
  <div className="min-h-screen animate-pulse" aria-busy="true" aria-label="Seite wird geladen">
    {/* Header-Balken */}
    <div className="border-b border-border bg-surface/80">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-4">
        <div className="h-9 w-9 rounded-full bg-surface-raised" />
        <div className="space-y-2">
          <div className="h-4 w-40 rounded bg-surface-raised" />
          <div className="h-3 w-24 rounded bg-surface-raised" />
        </div>
      </div>
    </div>

    {/* Content-Blöcke */}
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 space-y-4">
      <div className="h-12 rounded-xl bg-surface-raised" />
      <div className="h-32 rounded-xl bg-surface-raised" />
      <div className="h-32 rounded-xl bg-surface-raised" />
    </div>
  </div>
);

export default RouteFallback;
